/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER_GOOGLE = 'LOGIN_USER_GOOGLE';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* SEARCH */
export const SEARCH_GEO_COUNTRY = 'SEARCH_GEO_COUNTRY';
export const SEARCH_GEO_COUNTRY_SUCCESS = 'SEARCH_GEO_COUNTRY_SUCCESS';
export const SEARCH_GEO_COUNTRY_ERROR = 'SEARCH_GEO_COUNTRY_ERROR';
export const SEARCH_SUPPLIER_STATE = 'SEARCH_SUPPLIER_STATE';
export const SEARCH_SUPPLIER_STATE_SUCCESS = 'SEARCH_SUPPLIER_STATE_SUCCESS';
export const SEARCH_SUPPLIER_STATE_ERROR = 'SEARCH_SUPPLIER_STATE_ERROR';

/* REVIEW */
export const REVIEW_DETAIL = 'REVIEW_DETAIL';
export const REVIEW_DETAIL_SUCCESS = 'REVIEW_DETAIL_SUCCESS';
export const REVIEW_DETAIL_ERROR = 'REVIEW_DETAIL_ERROR';
export const REVIEW_ADD_SET= 'REVIEW_ADD_SET';
export const REVIEW_ADD_CHANGE= 'REVIEW_ADD_CHANGE';
export const REVIEW_EDIT_MODAL_SET= 'REVIEW_EDIT_MODAL_SET';
export const REVIEW_EDIT_TAB_SET= 'REVIEW_EDIT_TAB_SET';
export const REVIEW_SEARCH = 'REVIEW_SEARCH';
export const REVIEW_SEARCH_SUCCESS = 'REVIEW_SEARCH_SUCCESS';
export const REVIEW_SEARCH_ERROR = 'REVIEW_SEARCH_ERROR';
export const REVIEW_ADD = 'REVIEW_ADD';
export const REVIEW_ADD_SUCCESS = 'REVIEW_ADD_SUCCESS';
export const REVIEW_ADD_ERROR = 'REVIEW_ADD_ERROR';
export const REVIEW_ADD_MODAL_SET= 'REVIEW_ADD_MODAL_SET';
export const REVIEW_HEADER= 'REVIEW_HEADER';
export const REVIEW_SEARCH_REVIEW_STATE_LIST = 'REVIEW_SEARCH_REVIEW_STATE_LIST';
export const REVIEW_SEARCH_REVIEW_STATE_LIST_SUCCESS = 'REVIEW_SEARCH_REVIEW_STATE_LIST_SUCCESS';
export const REVIEW_SEARCH_REVIEW_STATE_LIST_ERROR = 'REVIEW_SEARCH_REVIEW_STATE_LIST_ERROR';
export const REVIEW_SEARCH_SUPPLIER_LIST = 'REVIEW_SEARCH_SUPPLIER_LIST';
export const REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS = 'REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS';
export const REVIEW_SEARCH_SUPPLIER_LIST_ERROR = 'REVIEW_SEARCH_SUPPLIER_LIST_ERROR';
export const REVIEW_LIST = 'REVIEW_LIST';
export const REVIEW_LIST_SUCCESS = 'REVIEW_LIST_SUCCESS';
export const REVIEW_LIST_ERROR = 'REVIEW_LIST_ERROR';
export const REVIEW_SEARCH_SET= 'REVIEW_SEARCH_SET';
export const REVIEW_SEARCH_CHANGE= 'REVIEW_SEARCH_CHANGE';
export const REVIEW_PAGE_SET= 'REVIEW_PAGE_SET';
export const REVIEW_VIEW_MODAL_SET= 'REVIEW_VIEW_MODAL_SET';
export const REVIEW_VIEW_DETAIL_MODAL_SET= 'REVIEW_VIEW_DETAIL_MODAL_SET';
export const REVIEW_VIEW_SET= 'REVIEW_VIEW_SET';
export const REVIEW_VIEW_TAB_SET= 'REVIEW_VIEW_TAB_SET';
export const REVIEW_EDIT_CHANGE = 'REVIEW_EDIT_CHANGE';
export const REVIEW_UPDATE = 'REVIEW_UPDATE';
export const REVIEW_UPDATE_SUCCESS = 'REVIEW_UPDATE_SUCCESS';
export const REVIEW_UPDATE_ERROR = 'REVIEW_UPDATE_ERROR';

/* SANCTION */
export const SANCTION_DETAIL = 'SANCTION_DETAIL';
export const SANCTION_DETAIL_SUCCESS = 'SANCTION_DETAIL_SUCCESS';
export const SANCTION_DETAIL_ERROR = 'SANCTION_DETAIL_ERROR';
export const SANCTION_VIEW_MODAL_SET= 'SANCTION_VIEW_MODAL_SET';

/* SUPPLIER */
export const SUPPLIER_DETAIL = 'SUPPLIER_DETAIL';
export const SUPPLIER_DETAIL_SUCCESS = 'SUPPLIER_DETAIL_SUCCESS';
export const SUPPLIER_DETAIL_ERROR = 'SUPPLIER_DETAIL_ERROR';
export const SUPPLIER_ADD_SET= 'SUPPLIER_ADD_SET';
export const SUPPLIER_ADD_CHANGE= 'SUPPLIER_ADD_CHANGE';
export const SUPPLIER_EDIT_MODAL_SET= 'SUPPLIER_EDIT_MODAL_SET';
export const SUPPLIER_EDIT_TAB_SET= 'SUPPLIER_EDIT_TAB_SET';
export const SUPPLIER_SEARCH = 'SUPPLIER_SEARCH';
export const SUPPLIER_SEARCH_SUCCESS = 'SUPPLIER_SEARCH_SUCCESS';
export const SUPPLIER_SEARCH_ERROR = 'SUPPLIER_SEARCH_ERROR';
export const SUPPLIER_ADD = 'SUPPLIER_ADD';
export const SUPPLIER_ADD_SUCCESS = 'SUPPLIER_ADD_SUCCESS';
export const SUPPLIER_ADD_ERROR = 'SUPPLIER_ADD_ERROR';
export const SUPPLIER_ADD_MODAL_SET= 'SUPPLIER_ADD_MODAL_SET';
export const SUPPLIER_HEADER= 'SUPPLIER_HEADER';
export const SUPPLIER_SEARCH_SUPPLIER_STATE_LIST = 'SUPPLIER_SEARCH_SUPPLIER_STATE_LIST';
export const SUPPLIER_SEARCH_SUPPLIER_STATE_LIST_SUCCESS = 'SUPPLIER_SEARCH_SUPPLIER_STATE_LIST_SUCCESS';
export const SUPPLIER_SEARCH_SUPPLIER_STATE_LIST_ERROR = 'SUPPLIER_SEARCH_SUPPLIER_STATE_LIST_ERROR';
export const SUPPLIER_SEARCH_SUPPLIER_LIST = 'SUPPLIER_SEARCH_SUPPLIER_LIST';
export const SUPPLIER_SEARCH_SUPPLIER_LIST_SUCCESS = 'SUPPLIER_SEARCH_SUPPLIER_LIST_SUCCESS';
export const SUPPLIER_SEARCH_SUPPLIER_LIST_ERROR = 'SUPPLIER_SEARCH_SUPPLIER_LIST_ERROR';
export const SUPPLIER_LIST = 'SUPPLIER_LIST';
export const SUPPLIER_LIST_SUCCESS = 'SUPPLIER_LIST_SUCCESS';
export const SUPPLIER_LIST_ERROR = 'SUPPLIER_LIST_ERROR';
export const SUPPLIER_SEARCH_SET= 'SUPPLIER_SEARCH_SET';
export const SUPPLIER_SEARCH_CHANGE= 'SUPPLIER_SEARCH_CHANGE';
export const SUPPLIER_PAGE_SET= 'SUPPLIER_PAGE_SET';
export const SUPPLIER_VIEW_MODAL_SET= 'SUPPLIER_VIEW_MODAL_SET';
export const SUPPLIER_VIEW_DETAIL_MODAL_SET= 'SUPPLIER_VIEW_DETAIL_MODAL_SET';
export const SUPPLIER_VIEW_SET= 'SUPPLIER_VIEW_SET';
export const SUPPLIER_VIEW_TAB_SET= 'SUPPLIER_VIEW_TAB_SET';
export const SUPPLIER_EDIT_CHANGE= 'SUPPLIER_EDIT_CHANGE';

/* AUTOREVIEW */
export const AUTOREVIEW_DETAIL = 'AUTOREVIEW_DETAIL';
export const AUTOREVIEW_DETAIL_SUCCESS = 'AUTOREVIEW_DETAIL_SUCCESS';
export const AUTOREVIEW_DETAIL_ERROR = 'AUTOREVIEW_DETAIL_ERROR';
export const AUTOREVIEW_ADD_SET= 'AUTOREVIEW_ADD_SET';
export const AUTOREVIEW_ADD_CHANGE= 'AUTOREVIEW_ADD_CHANGE';
export const AUTOREVIEW_EDIT_MODAL_SET= 'AUTOREVIEW_EDIT_MODAL_SET';
export const AUTOREVIEW_EDIT_TAB_SET= 'AUTOREVIEW_EDIT_TAB_SET';
export const AUTOREVIEW_SEARCH = 'AUTOREVIEW_SEARCH';
export const AUTOREVIEW_SEARCH_SUCCESS = 'AUTOREVIEW_SEARCH_SUCCESS';
export const AUTOREVIEW_SEARCH_ERROR = 'AUTOREVIEW_SEARCH_ERROR';
export const AUTOREVIEW_ADD = 'AUTOREVIEW_ADD';
export const AUTOREVIEW_ADD_SUCCESS = 'AUTOREVIEW_ADD_SUCCESS';
export const AUTOREVIEW_ADD_ERROR = 'AUTOREVIEW_ADD_ERROR';
export const AUTOREVIEW_ADD_MODAL_SET= 'AUTOREVIEW_ADD_MODAL_SET';
export const AUTOREVIEW_HEADER= 'AUTOREVIEW_HEADER';
export const AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST = 'AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST';
export const AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST_SUCCESS = 'AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST_SUCCESS';
export const AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST_ERROR = 'AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST_ERROR';
export const AUTOREVIEW_SEARCH_SUPPLIER_LIST = 'AUTOREVIEW_SEARCH_SUPPLIER_LIST';
export const AUTOREVIEW_SEARCH_SUPPLIER_LIST_SUCCESS = 'AUTOREVIEW_SEARCH_SUPPLIER_LIST_SUCCESS';
export const AUTOREVIEW_SEARCH_SUPPLIER_LIST_ERROR = 'AUTOREVIEW_SEARCH_SUPPLIER_LIST_ERROR';
export const AUTOREVIEW_LIST = 'AUTOREVIEW_LIST';
export const AUTOREVIEW_LIST_SUCCESS = 'AUTOREVIEW_LIST_SUCCESS';
export const AUTOREVIEW_LIST_ERROR = 'AUTOREVIEW_LIST_ERROR';
export const AUTOREVIEW_SEARCH_SET= 'AUTOREVIEW_SEARCH_SET';
export const AUTOREVIEW_SEARCH_CHANGE= 'AUTOREVIEW_SEARCH_CHANGE';
export const AUTOREVIEW_PAGE_SET= 'AUTOREVIEW_PAGE_SET';
export const AUTOREVIEW_VIEW_MODAL_SET= 'AUTOREVIEW_VIEW_MODAL_SET';
export const AUTOREVIEW_VIEW_DETAIL_MODAL_SET= 'AUTOREVIEW_VIEW_DETAIL_MODAL_SET';
export const AUTOREVIEW_VIEW_SET= 'AUTOREVIEW_VIEW_SET';
export const AUTOREVIEW_VIEW_TAB_SET= 'AUTOREVIEW_VIEW_TAB_SET';
export const AUTOREVIEW_EDIT_CHANGE = 'AUTOREVIEW_EDIT_CHANGE';
export const AUTOREVIEW_UPDATE = 'AUTOREVIEW_UPDATE';
export const AUTOREVIEW_UPDATE_SUCCESS = 'AUTOREVIEW_UPDATE_SUCCESS';
export const AUTOREVIEW_UPDATE_ERROR = 'AUTOREVIEW_UPDATE_ERROR';

export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './search/actions';
export * from './review/actions';
export * from './sanction/actions';
export * from './supplier/actions';
export * from './autoreview/actions';